import { useAuthState } from "react-firebase-hooks/auth";
import { useQuery } from "react-query";
import { auth } from "../firebase";
import { fetchPartnerCampaignProducts } from "../services/partner/partner.api";
import { useUserPartnerInformation } from "./useUserPartnerInformation";

export function usePartnerCampaignProducts() {
  const [user] = useAuthState(auth);

  const { userPartnerInformation } = useUserPartnerInformation(user?.uid);

  const partnerId = userPartnerInformation?.data?.partnerId;

  return useQuery(
    ["partnerCampaignProducts", partnerId],
    () => fetchPartnerCampaignProducts(partnerId),
    { enabled: !!partnerId, select: (data) => data.data }
  );
}
